module.exports = __webpack_public_path__ + "img/error.c8081e81.png";